import React, { useState, useEffect } from "react";


import "./style.css";
import { getOrders } from "../../api/kd";
import { addIdKeyIfMissing } from "@delibrandev/utils/src/function.js";
import { orderIdentifier } from "../../helpers/orderIdentifier";

export const ReadyOrders = () => {
  const reCallInMs = 25000;
  const [readyOrders, setReadyOrders] = useState([]);
  const [inPreparationOrders, setInPreparationOrders] = useState([]);

  const query = async () => {
    const payload = {
      page: 0,
      pageSize: 1000,
      orderStatus: "prepared",
      sortOrder: "ASC",
    };
    const response = await getOrders(payload);
    if (response && !response.error) {
      setReadyOrders(addIdKeyIfMissing(response.data.orders.filter((f) => f.status === "prepared")));
    }

    const payloadInPreparation = {
      page: 0,
      pageSize: 1000,
      orderStatus: "inPreparation",
      sortOrder: "ASC",
    };
    const responseInPreparation = await getOrders(payloadInPreparation);
    if (responseInPreparation && !responseInPreparation.error) {
      setInPreparationOrders(addIdKeyIfMissing(responseInPreparation.data.orders.filter((f) => f.status === "inPreparation")));
    }
  };

  useEffect(() => {
    query();
    const interval = setInterval(() => {
      query();
    }, reCallInMs);

    return () => clearInterval(interval); // Limpieza al desmontar
  }, []);

  return (
    <>
      <div className="kitchen-ready-title">PEDIDOS</div>
      <div className="kitchen-ready">
        <div className="kitchen-ready-preparationColumn">
          <div className="kitchen-ready-title">EN PREPARACIÓN</div>
          <div className="kitchen-ready-body">
            {inPreparationOrders &&
              inPreparationOrders.length > 0 &&
              inPreparationOrders.map((order) => (
                <div key={order.orderId} className="order-number">
                  {orderIdentifier(order)}
                </div>
              ))}
          </div>
        </div>
        <div className="kitchen-ready-readyColumn">
          <div className="kitchen-ready-title">LISTOS</div>
          <div className="kitchen-ready-body">
            {readyOrders &&
              readyOrders.length > 0 &&
              readyOrders.map((order) => (
                <div key={order.orderId} className="order-number">
                  {orderIdentifier(order)}
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};
